import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_4: FaireProductEntity = {
  token: "sweet-wink-4",
  type: "product",
  name: "Cheer Pearl Patch Short Sleeve T-Shirt - Girls Clothes",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/f4c157f519cf39bcd8c005652987898798f6880173b1c2793020b3253460ce3e.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1079,1079,x0,y0,safe&width=720",
  priceDollars: 14,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
